import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { greenTickThick, green_tick_dark, stepathon_img } from '../../../assets/images'
import { Stepathon_list_headers } from '../../../constants/tableHeaders'
import { stepathonListPageSchema } from '../../../../src/schemas/table'
import { StepathonApi } from '../../../services'
import { Breadcrumb, Spinner } from '../../common/atoms'
import { handleAppError } from '../../handlers'
import { successOrFailureToaster } from '../../common/atoms/messages'
import { Tabbar, Table } from '../../common/molecules'
import { NoUtilizationCard} from '../../common/organisms'
import StepathonModal from '../../modals/StepathonModel'
import { StepathonUtilization } from '../../tailwind/organisms'
import { IntegrationSuccessModal } from '../../modals'

const StepathonPage = () => {
  const history = useHistory()
  const location = useLocation()
  const [state, setState] = useState(
    {
      tableData : [],
      locationData: null,
      teamImportModal : false,
      yetToStartData:[],
      ongoingData:[],
      finishedData:[],
      currentTab:'',
      enableModal : false,
      disableModal : false,
      stepathon_id : '',
      status : '',
      tableLoading : true,
      showUtilization : false,
      disableCreateStepathon : [],
      stepathonType: 'team',
      total_employee_count: 0
    }
  )
  const list = useRef([])
  const setSubState = (newState) => {
    setState(prevState => { return {...prevState, ...newState} })
  }

  const navigateToCreateStepathon = () => {
    history.push({pathname : 'stepathon/create-stepathon', state : {disabled: state.disableCreateStepathon, total_employee_count: state.total_employee_count}})
  }

  const  fetchStepathonList = () =>{
    StepathonApi.fetchStepathonList(
      {},
      (resp) => {
        const data = resp.data.stepathons
        const yetToStartData = data.filter((item)=> item.tag === 'Yet to Start')
        const ongoingData = data.filter((item)=> item.tag === 'Ongoing')
        const finishedData = data.filter((item)=> item.tag === 'Finished')
        let alreadyCreatedStepathons = [
          ...yetToStartData,
          ...ongoingData
      ].map(item => item.stepathon_type);
      const uniqueStepathonTypes = [...new Set(alreadyCreatedStepathons)];
        list.current = [`Ongoing (${ongoingData.length})`, `Yet to start (${yetToStartData.length})`, `Finished (${finishedData.length})`]
        if(data.length > 0)
        setSubState({tableData : ongoingData, total_employee_count: resp.data.total_employee_count, yetToStartData: yetToStartData, ongoingData:ongoingData, finishedData:finishedData,  tableLoading : false, showUtilization : false, currentTab: `Ongoing (${ongoingData.length})`, disableCreateStepathon : uniqueStepathonTypes})
        else setSubState({showUtilization : true, tableLoading : false})
      },
      (err) => {
        handleAppError(err);
        setSubState({tableLoading : false})
      }
    );
  }
  useEffect(()=>{
    fetchStepathonList()
    let importData = sessionStorage.getItem('empDataImport') === 'close'
    if(location.state && location.state?.stepathon_mode === 'closed' && !importData ){
      let val = state.teamImportModal
      let type = location.state?.stepathon_type
      setSubState({teamImportModal : !val, 
                   locationData : location.state,
                   stepathonType: type})
    }
  },[location])
 
  const editStepathon = (data) =>{
    if(data.tag !== 'Finished' && data.status !== 'deactivate'){
      history.push({pathname: 'stepathon/update-stepathon', state : {data, total_employee_count: state.total_employee_count}})
    }
  }

  const onToggleHandler = () =>{
    let {stepathon_id, status} = state
    if(status === 'activate'){
      StepathonApi.activateStepathon(
        { id : stepathon_id , data : { 'status' : status}},
        (_) => {
          let newData = state.tableData.map((item) =>{
            if(item.id === stepathon_id)
              item['status'] = status
            return item
          })
          setSubState({tableData : newData})
          successOrFailureToaster({ message: 'Stepathon is succesfully enabled' })
        },
        (err) => {
          handleAppError(err);
        }
      );
      setSubState({enableModal : false})
    }
  else{
    StepathonApi.deactivateStepathon(
        { id : stepathon_id , data : { 'status' : status}},
        (_) => {
          let newData = state.tableData.map((item) =>{
            if(item.id === stepathon_id)
              item['status'] = status
            return item
          })
          setSubState({tableData : newData})
          successOrFailureToaster({ message: 'Stepathon is succesfully disabled'})
        },
        (err) => {
          handleAppError(err);
        }
      );
      setSubState({disableModal : false})
    }
  }
 
  let openModal = (e, stepathon_id) => {
    let value = e.value
   if(value) {
     value = 'activate'
     setSubState({ enableModal : !state.enableModal})
   }
   else{
     value = 'deactivate'
     setSubState({disableModal : !state.disableModal})
   }
   setSubState({ stepathon_id : stepathon_id , status : value})
  }
 
  const goToLeaderboard = (data) => {
    if(data.tag !== 'Yet to Start' && data.status !== 'deactivate'){
    history.push({pathname: 'stepathon/leader-board', state : data})
    }
  }

  let getLabel = () =>  {
    if(state.currentTab === `Ongoing (${state.ongoingData.length})`) return 'No ongoing stepathon'
    else if(state.currentTab === `Yet to start (${state.yetToStartData.length})` ) return 'No upcoming stepathon'
    else return 'No finished stepathon'
  }

  const navigateTab = (tab) =>{
    let newState = {}
    if (tab.text === `Yet to start (${state.yetToStartData.length})`){
      newState ={...newState, tableData : state.yetToStartData}
    }
    else if(tab.text === `Finished (${state.finishedData.length})`){
      newState ={...newState, tableData : state.finishedData}
    }
    else     newState ={...newState, tableData : state.ongoingData}
    
    setSubState({...newState, currentTab : tab.text})
  }

  const UploadAndViewTeams = (type, data) =>{
    if(type === 'upload_teams') {
      history.push({pathname: 'stepathon/team-upload', state : {stepathon_id : data.id}})
    }
    else if(type === 'upload_members') {
      history.push({pathname: 'stepathon/member-upload', state : {stepathon_id : data.id}})
    } else if(type === 'view_members') {
      history.push({pathname: 'stepathon/view-members', state : data})
    }
    else history.push({pathname: 'stepathon/view-teams', state : data})
  }

  const navigateToTeamUploadPage = () => {
    const teamImportVal = state.teamImportModal
    let pathname = ''
    setSubState({teamImportModal: !teamImportVal})
    if (state.stepathonType === 'individual') pathname = 'member-upload'
    else pathname = 'team-upload'
    sessionStorage.setItem('empDataImport', 'close')
    history.push({ pathname: `/stepathon/${pathname}` , state : { stepathon_id : state.locationData.id}})
  }

  const closeModal = () => {
    const value = state.teamImportModal
    setSubState({teamImportModal :  !value})
    sessionStorage.setItem('empDataImport', 'close')
  }

 return (
    <Spinner visible={state.tableLoading} classes='ml-32 z-10' >
      <React.Fragment>
        <div className='flex flex-row justify-between'>
          <div>
            <Breadcrumb
              list={[
                { text: 'Engagement', link: '/stepathon' },
                { text: 'Stepathon', link: '/stepathon' },
              ]}
              classes='mb-1'
            />
            <p className='text-gray-900 text-xl font-semibold leading-5 mb-0'>Stepathon</p>
          </div>
          <button
            type='button'
            onClick={navigateToCreateStepathon}
            style={{height: '44px', width: '172px'}}
            className='block rounded-md leading-5 px-6 py-3 bg-blue-600  text-base font-semibold text-white focus:outline-none'
          >
            Create stepathon
          </button>
        </div> 
        { !state.showUtilization  &&
          <div className='mt-6'>
            <Tabbar  
              titleClasses = 'pb-3 leading-4'
              list= {[{text : list.current[0]}, {text : list.current[1]}, {text: list.current[2]}]}
              currentPage = { state.currentTab ?? `Ongoing (${state.ongoingData.length})`}
              setContract={navigateTab}
            />
          </div>
         }
        <div className='mt-6'>
        {
            !state.showUtilization ?
            <div>
            { state.tableData.length !== 0 ?
                <Table
                  headers={Stepathon_list_headers}
                  data={state.tableData || []}
                  loading={state.tableLoading}
                  tableClasses='alternate_gray200_color'
                  tableschema={stepathonListPageSchema}
                  classes='rounded-md'
                  editStepathon={editStepathon}
                  openModal={openModal}
                  openLeaderBoard ={goToLeaderboard}
                  UploadAndViewTeams={UploadAndViewTeams}
                />
                :
                <div>
                  <StepathonUtilization
                    color = 'white'
                    label={getLabel(state.currentTab)}
                    title={state.currentTab === `Ongoing (${state.ongoingData.length})` &&  'To increase the engagement, please create stepathon'}
                    btnText={state.currentTab === `Ongoing (${state.ongoingData.length})` && 'Create stepathon'}
                    handler={navigateToCreateStepathon}
                  />
                </div>
            }
            </div>
          :
            <NoUtilizationCard
              imgsrc={stepathon_img}
              line='the stepathon created by you'
              parent ='stepathon'
              toggleHelp={navigateToCreateStepathon}
            />
        }
        </div>
        {  state.enableModal   &&
            <StepathonModal visible={state.enableModal} icon={green_tick_dark} title='Do you want to enable the stepathon?' description='Enabling of stepathon means it will be visible to your employees. You can disable it before the start date.'
              onCancel={() => {
              setSubState({enableModal : false})
            } }
            handler={() => onToggleHandler()}
        />}
        {  state.disableModal   &&
            <StepathonModal  visible={state.disableModal} title='Do you want to disable the stepathon?' description='Disabiling of stepathon means it won’t be visible to the employees. You can enable it anytime.'
            onCancel={() => {
            setSubState({disableModal : false})
            } }
            handler={() => onToggleHandler()}
        />}
          {
            state.teamImportModal &&
            <IntegrationSuccessModal
              visible={state.teamImportModal}
              icon={greenTickThick}
              heading='Stepathon is succesfully created'
              body={<p>Great choice! You've selected the <span className='font-semibold text-blue-600'>"Closed stepathon."</span> To activate this challenge, please upload your team list as a CSV or XLSX file. Don't worry, the process is simple and quick. Just follow the instructions below to get started.</p>}
              btnText={state.stepathonType === 'individual' ? 'Import members' : 'Import teams'}
              btnHandler={navigateToTeamUploadPage}
              handler={closeModal}
              modelHeight='24rem'
              disableBtn={false}
            />
          }
      </React.Fragment>
    </Spinner>
  )
}
 
export default StepathonPage